<template>
  <div v-if="currentStyle">
    <template v-for="input of inputs">
      <ruleGroupInput
        v-if="input.children && input.children.length > 0"
        :key="input.value"
        :field="input"
        v-model="currentStyle"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      />
      <rule-field-name
        v-else-if="input.type == 'field-label'"
        :label="input.label"
        :key="input.value + '-label'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-name>
      <rule-field-array
        v-else-if="input.type == 'field-array'"
        :label="input.label"
        :key="input.value + '-array'"
        :fields="fields"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-array>
      <rule-field-image
        v-else-if="input.type == 'image'"
        :label="input.label"
        :key="input.value + '-image'"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></rule-field-image>
      <ruleInput
        v-else
        :typeInput="input.type"
        :label="input.label"
        :key="input.value + '-else'"
        :option="input.option"
        v-model="currentStyle[input.value]"
        @input="changeStyle"
        :autocomplete="input.autocomplete"
      ></ruleInput>
    </template>

    <v-btn
      v-if="otherInput.length > 0"
      text
      @click="isAdvanced = !isAdvanced"
      :color="isAdvanced ? 'primary' : ''"
    >
      {{ $t('preview.actions.advanced') }}
    </v-btn>
    <template v-if="isAdvanced">
      <template v-for="input of otherInput">
        <ruleGroupInput
          v-if="input.children && input.children.length > 0"
          :key="input.value"
          :field="input"
          v-model="currentStyle"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        />
        <rule-field-name
          v-else-if="input.type == 'field-label'"
          :label="input.label"
          :key="input.value + '-label'"
          :fields="fields"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-name>
        <rule-field-array
          v-else-if="input.type == 'field-array'"
          :label="input.label"
          :key="input.value + '-array'"
          :fields="fields"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-array>
        <rule-field-image
          v-else-if="input.type == 'image'"
          :label="input.label"
          :key="input.value + '-image'"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></rule-field-image>
        <ruleInput
          v-else
          :typeInput="input.type"
          :label="input.label"
          :key="input.value + '-else'"
          :option="input.option"
          v-model="currentStyle[input.value]"
          @input="changeStyle"
          :autocomplete="input.autocomplete"
        ></ruleInput>
      </template>
    </template>
  </div>
</template>

<script>
import asyncComponent from '@/src/components/async'

import ruleGroupInput from '../input/edit-rule-group-input.vue'
import ruleInput from '../input/edit-rule-input.vue'

export default {
  components: {
    ruleInput,
    ruleGroupInput,
    RuleFieldName: () => asyncComponent(import('../input/rule-field-name.vue')),
    RuleFieldArray: () =>
      asyncComponent(import('../input/rule-field-array.vue')),
    RuleFieldImage: () =>
      asyncComponent(import('../input/rule-field-image.vue')),
  },
  props: {
    value: {},
    typeLayer: String,
    fields: { type: Array },
  },
  data: () => ({
    isAdvanced: false,
    otherInput: [],
    inputs: [],
    currentStyle: {},
  }),
  watch: {
    value: {
      handler(value) {
        this.currentStyle = value || {}
      },
      immediate: true,
      deep: true,
    },
    typeLayer: {
      handler(value) {
        let input = defautInput[value] || Text
        this.inputs = input.default
        this.otherInput = input.other
        this.isAdvanced = false
      },
      immediate: true,
    },
  },
  methods: {
    changeStyle() {
      this.$emit('input', this.currentStyle)
    },
  },
}

const TRANSLATE_ANCHOR_ITEMS = [
  { text: 'map', value: 'map' },
  { text: 'viewport', value: 'viewport' },
]

let Point = {
  default: [
    {
      label: 'Biểu tượng',
      value: 'icon',
      type: 'icon',
    },
    {
      label: 'Độ trong suốt',
      value: 'opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Kích cỡ',
      value: 'size',
      acceptsExpression: true,
      defaultValue: 5,
      type: 'integer',
      option: {
        min: 0,
      },
    },
  ],
  other: [
    {
      label: 'Độ mờ (circle-blur)',
      value: 'circle-blur',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Dịch chuyển (circle-translate)',
      value: 'circle-translate',
      type: 'field-array',
      defaultValue: [0, 0],
    },
    {
      label: 'Neo dịch chuyển',
      value: 'circle-translate-anchor',
      type: 'v-select',
      defaultValue: 'map',
      option: { items: TRANSLATE_ANCHOR_ITEMS },
    },
    {
      label: 'Pitch alignment',
      value: 'circle-pitch-alignment',
      type: 'v-select',
      defaultValue: 'viewport',
      option: {
        items: [
          { text: 'map', value: 'map' },
          { text: 'viewport', value: 'viewport' },
        ],
      },
    },
    {
      label: 'Pitch scale',
      value: 'circle-pitch-scale',
      type: 'v-select',
      defaultValue: 'map',
      option: {
        items: [
          { text: 'map', value: 'map' },
          { text: 'viewport', value: 'viewport' },
        ],
      },
    },
    {
      label: 'Xoay icon',
      value: 'icon-rotate',
      type: 'number',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Neo icon',
      value: 'icon-anchor',
      type: 'v-select',
      defaultValue: 'center',
      option: {
        items: [
          { text: 'center', value: 'center' },
          { text: 'left', value: 'left' },
          { text: 'right', value: 'right' },
          { text: 'top', value: 'top' },
          { text: 'bottom', value: 'bottom' },
          { text: 'top-left', value: 'top-left' },
          { text: 'top-right', value: 'top-right' },
          { text: 'bottom-left', value: 'bottom-left' },
          { text: 'bottom-right', value: 'bottom-right' },
        ],
      },
    },
    {
      label: 'Độ lệch icon',
      value: 'icon-offset',
      type: 'field-array',
      defaultValue: [0, 0],
    },
    {
      label: 'Cho phép chồng lấp icon',
      value: 'icon-allow-overlap',
      type: 'v-checkbox',
      defaultValue: false,
    },
    {
      label: 'Bỏ qua va chạm icon',
      value: 'icon-ignore-placement',
      type: 'v-checkbox',
      defaultValue: false,
    },
  ],
}

let Polygon = {
  default: [
    {
      label: 'Màu',
      value: 'fill',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ trong suốt',
      value: 'fill-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Sử dụng viền?',
      value: 'use_stroke',
      children: [
        {
          label: 'Màu viền',
          value: 'stroke',
          type: 'color',
          acceptsExpression: true,
          defaultValue: '#000000',
        },
      ],
    },
    {
      label: 'Biểu tượng',
      value: 'fill-pattern-image_id',
      type: 'image',
    },
  ],
  other: [
    {
      label: 'Khử răng cưa (fill-antialias)',
      value: 'fill-antialias',
      type: 'v-checkbox',
      defaultValue: true,
    },
    {
      label: 'Dịch chuyển (fill-translate)',
      value: 'fill-translate',
      type: 'field-array',
      defaultValue: [0, 0],
    },
    {
      label: 'Neo dịch chuyển',
      value: 'fill-translate-anchor',
      type: 'v-select',
      defaultValue: 'map',
      option: { items: TRANSLATE_ANCHOR_ITEMS },
    },
  ],
}

let Line = {
  default: [
    {
      label: 'Màu viền',
      value: 'stroke',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ dày',
      value: 'stroke-width',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Độ trong suốt viền',
      value: 'stroke-opacity',
      type: 'percentage',
      defaultValue: 1,
    },
    {
      label: 'Dasharray',
      value: 'stroke-dasharray',
      type: 'field-array',
      defaultValue: [],
    },
    {
      label: 'Chóp',
      value: 'line-cap',
      type: 'v-select',
      defaultValue: 'butt',
      option: {
        items: [
          { text: 'butt', value: 'butt' },
          { text: 'round', value: 'round' },
          { text: 'square', value: 'square' },
        ],
      },
    },
    {
      label: 'Khớp nối',
      value: 'line-join',
      type: 'v-select',
      defaultValue: 'miter',
      option: {
        items: [
          { text: 'miter', value: 'miter' },
          { text: 'round', value: 'round' },
          { text: 'bevel', value: 'bevel' },
        ],
      },
    },
    {
      label: 'Biểu tượng',
      value: 'line-pattern-image_id',
      type: 'image',
    },
  ],
  other: [
    {
      label: 'Độ mờ (line-blur)',
      value: 'line-blur',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Độ lệch (line-offset)',
      value: 'line-offset',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Khoảng trống (line-gap-width)',
      value: 'line-gap-width',
      type: 'length',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Giới hạn miter',
      value: 'line-miter-limit',
      type: 'number',
      defaultValue: 2,
    },
    {
      label: 'Giới hạn round',
      value: 'line-round-limit',
      type: 'number',
      defaultValue: 1.05,
    },
    {
      label: 'Dịch chuyển (line-translate)',
      value: 'line-translate',
      type: 'field-array',
      defaultValue: [0, 0],
    },
    {
      label: 'Neo dịch chuyển',
      value: 'line-translate-anchor',
      type: 'v-select',
      defaultValue: 'map',
      option: { items: TRANSLATE_ANCHOR_ITEMS },
    },
  ],
}

let Text = {
  default: [
    {
      label: 'Trường hiển thị',
      value: 'label',
      type: 'field-label',
      defaultValue: 'name',
    },
    {
      label: 'Phông chữ',
      value: 'font-family',
      type: 'font',
      defaultValue: 'Arial Regular',
    },
    {
      label: 'Kiểu',
      value: 'font-style',
      type: 'v-select',
      defaultValue: 'normal',
      option: {
        items: [
          { text: 'Bình thường', value: 'normal' },
          { text: 'In đậm', value: 'bold' },
          { text: 'In nghiêng', value: 'italic' },
          { text: 'Gạch chân', value: 'oblique' },
        ],
      },
    },
    {
      label: 'Kích cỡ',
      value: 'font-size',
      defaultValue: 10,
      type: 'integer',
      option: {
        min: 0,
      },
    },
    {
      label: 'Màu',
      value: 'fill',
      type: 'color',
      acceptsExpression: true,
      defaultValue: '#000000',
    },
    {
      label: 'Độ trong suốt',
      value: 'fill-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
  ],
  other: [],
}

let Raster = {
  default: [
    {
      label: 'Độ trong suốt',
      value: 'raster-opacity',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Độ sáng tối thiểu',
      value: 'raster-brightness-min',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Độ sáng tối đa',
      value: 'raster-brightness-max',
      type: 'percentage',
      acceptsExpression: true,
      defaultValue: 1,
    },
    {
      label: 'Độ bão hòa',
      value: 'raster-saturation',
      type: 'number',
      acceptsExpression: true,
      defaultValue: 0,
      option: { min: -1, max: 1, step: 0.01 },
    },
    {
      label: 'Độ tương phản',
      value: 'raster-contrast',
      type: 'number',
      acceptsExpression: true,
      defaultValue: 0,
      option: { min: -1, max: 1, step: 0.01 },
    },
  ],
  other: [
    {
      label: 'Xoay hue (°)',
      value: 'raster-hue-rotate',
      type: 'number',
      acceptsExpression: true,
      defaultValue: 0,
    },
    {
      label: 'Thời gian fade (ms)',
      value: 'raster-fade-duration',
      type: 'number',
      defaultValue: 300,
      option: { min: 0 },
    },
    {
      label: 'Resampling',
      value: 'raster-resampling',
      type: 'v-select',
      defaultValue: 'linear',
      option: {
        items: [
          { text: 'linear', value: 'linear' },
          { text: 'nearest', value: 'nearest' },
        ],
      },
    },
  ],
}

let defautInput = { Point, Polygon, Line, Text, Raster }
</script>

<style></style>
